import {
  CLEAR_SWITCH_RES,
  CLINIC_LIST_RES,
  SWITCH_CLINIC_RES,
} from './clinic.types'

const INITIAL_STATE = {
  clinicList: [],
  switchClinicResponse: {},
}

const clinicReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CLINIC_LIST_RES:
      return { ...state, clinicList: action.payload.response.data }
    case SWITCH_CLINIC_RES:
      return { ...state, switchClinicResponse: action.payload.response }
    case CLEAR_SWITCH_RES:
      return { ...state, switchClinicResponse: {} }

    default:
      return state
  }
}
export default clinicReducer
